<template>
  <div class="page_pendInvoice">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoicing', query:{activeName} }">开票申请</el-breadcrumb-item>
          <el-breadcrumb-item>查看</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs v-model="active" type="card" @tab-click="handleClick" class="s_tabs_box" v-if="type!='view'">
        <el-tab-pane :disabled="loading" label="流程信息" name="first"></el-tab-pane>
        <el-tab-pane :disabled="loading" label="工作流" name="second"></el-tab-pane>
        <el-tab-pane :disabled="loading" label="操作记录" name="third"></el-tab-pane>
      </el-tabs>
      <div class="p_employee_box" v-if="active == 'first' && isOver" v-loading="loading">
        <div class="p_employee_list">
          <div class="r_edit_title">
            <div class="line_box"></div>基础信息
          </div>
          <div class="p_employee_form">
            <div class="p_employee_item">
              <p class="emp_txt">开票申请编号:</p>
              <div class="emp_form_txt">
                {{baseInfo.invoiceNo}}
              </div>
            </div>
            <div class="p_employee_item">
              <!-- 项目或部门 -->
              <p class="emp_txt">开票项目/部门:</p>
              <div class="emp_form_txt">
                {{baseInfo.ownershipName}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">状态:</p>
              <div class="emp_form_txt">
                {{baseInfo.status}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">申请人:</p>
              <div class="emp_form_txt">
                {{baseInfo.applicant}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">电话:</p>
              <div class="emp_form_txt">
                {{baseInfo.telephone}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">申请时间:</p>
              <div class="emp_form_txt">
                {{baseInfo.applicationTime ? baseInfo.applicationTime.replace('T',' ') : '' }}
              </div>
            </div>
            <!-- <div class="p_employee_item">
              <p class="emp_txt">退回人:</p>
              <div class="emp_form_txt">
                {{baseInfo.dtEntryDate}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">退回时间:</p>
              <div class="emp_form_txt">
                {{baseInfo.dtEntryDate}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">退回备注:</p>
              <div class="emp_form_txt">
                {{baseInfo.dtEntryDate}}
              </div>
            </div> -->
          </div>
          <!-- 发票开具申请单 -->
          <!-- <div class="flex aic print_box">
            <el-button type="text" @click="printClick('printBox','')">打印</el-button>
          </div>
          <div class="com_form_box">
            <div id="printBox">
              <div class="centerTitle">发票开具申请单</div>
              <table width="100%" border="0" cellspacing="1" cellpadding="4" class="tabtop form_table" align="center">
                <tr>
                  <td class="btbg font-center">*合伙人</td>
                  <td>{{appInfo.partner}}</td>
                  <td class="btbg font-center">*业务员</td>
                  <td>{{appInfo.salesman}}</td>
                  <td class="btbg font-center">*开票申请人</td>
                  <td colspan="3">{{appInfo.applicant}}</td>
                </tr>
                <tr>
                  <td class="btbg font-center">*服务部门</td>
                  <td>{{appInfo.serviceDepartment}}</td>
                  <td class="btbg font-center">*客服</td>
                  <td>{{appInfo.customerService}}</td>
                  <td class="btbg font-center">*法务主体</td>
                  <td colspan="3">{{appInfo.strLegalsubName}}</td>
                </tr>
                <tr>
                  <td class="btbg font-center">*客户名称</td>
                  <td colspan="4">{{appInfo.strCustName}}</td>
                  <td colspan="3">纳税人识别号：{{appInfo.ratepayerNo}}</td>
                </tr>
                <tr>
                  <td class="btbg font-center" :rowspan="invoiceRequisitionDetailsViewList.length + 3">*开票内容</td>
                  <td class="btbg font-center">开票方式</td>
                  <td class="btbg font-center">开票项目</td>
                  <td class="btbg font-center">含税金额(元)</td>
                  <td class="btbg font-center">票据种类</td>
                  <td class="btbg" colspan="3">业务类型:{{appInfo.businessTypeId}}</td>
                </tr>
                <tr v-for="(item,index) in invoiceRequisitionDetailsViewList" :key="index">
                  <td class="btbg font-center">{{appInfo.billingMethod}}</td>
                  <td class="btbg font-center">{{ item.billingContent }}</td>
                  <td class="btbg font-center">{{ item.amount }}</td>
                  <td class="btbg font-center">{{ item.ticketType }}</td>
                  <td class="btbg font-center"></td>
                </tr>
                <tr>
                  <td class="btbg font-center">金额合计:</td>
                  <td class="btbg" colspan="3">￥{{appInfo.sumAmountApplied}}</td>
                  <td class="btbg" colspan="3">备注{{appInfo.remark}}</td>
                </tr>
                <tr>
                  <td class="btbg" colspan="5">
                    <p>营业地址:{{appInfo.businessAddress}}</p>
                    <p>电话:{{appInfo.telephone}}</p>
                    <p>开户行账号:{{appInfo.bankOfDeposit}}</p>
                  </td>
                </tr>
                <tr>
                  <td class="btbg" colspan="2">收票地址、联系人及电话(快递信息):</td>
                  <td class="btbg" colspan="6"></td>
                </tr>
                <tr>
                  <td class="btbg font-center">申请开票日期:</td>
                  <td class="btbg" colspan="7">{{baseInfo.applicationTime ? baseInfo.applicationTime.replace('T',' ') : ''}}</td>
                </tr>
                <tr>
                  <td class="btbg font-center">合同附件:</td>
                  <td class="btbg" colspan="7"></td>
                </tr>
                <tr>
                  <td class="btbg font-center">结算的附件:</td>
                  <td class="btbg" colspan="7">
                    <span v-for="(f,index) in invoiceFiles" :key="index" class="blueName cp" @click="down(f.fileUrl)" style="margin-right: 15px;">{{f.fileName}}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div> -->
        </div>
        <div class="p_employee_list">
          <div class="r_edit_title">
            <div class="line_box"></div>发票申请
          </div>
          <el-table class="doc_table" border :data="invoiceRequisitionDetailsViewList" style="width:100%">
            <el-table-column align="center" prop="invoiceItem" label="发票项目" min-width="200px">
            </el-table-column>
            <el-table-column align="center" prop="type" label="发票类型" min-width="150px" fit :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column align="center" prop="invoicingName" label="开票内容" min-width="200px" fit :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column align="center" prop="applyForAmount" label="开票金额" min-width="200px" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}"> ￥ {{ row.applyForAmount}} {{ row.taxInclusiveLabel==1 ? '（含税）' : '（不含税）' }}</template>
            </el-table-column>
          </el-table>
          <div class="merge" style="font-size: 14px;">开票备注：{{ appInfo.billingNote }}</div>
          <div class="merge flex">
            <el-checkbox v-model="appInfo.isConsolidatedBilling" :true-label="1" :false-label="0" disabled>服务费/管理费与工资/社保/个税合开在一张发票上（仅适用差额开票）</el-checkbox>
            <!-- <div class="sumAmount">开票金额合计：￥{{ applyForAmount[i].sum }}</div> -->
          </div>
        </div>
        <div class="p_employee_list">
          <div class="r_edit_title">
            <div class="line_box"></div>对应结算单
          </div>
          <div class="dtl_table">
            <el-table border :data="finalStatementViewList" style="width:100%">
              <!-- 项目或部门 -->
              <el-table-column align="center" label="项目/部门" min-width="160px">
                <template slot-scope="{row}">
                  <span>{{row.ownershipName}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="归属月" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.ownershipMonth}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="结算单编号" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.finalStatementNo}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="结算单金额" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.settlementAmount}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="本次开具金额" min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.amountApplied}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="创建时间" min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.createTime ? row.createTime.replace('T',' ') : ''}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="附件" min-width="160px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <div class="blueName cp" v-for="(item,index) in row.files" :key="index" @click="down(item.fileUrl)">{{ item.fileName }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <p class="d_txt">结算单本次开具发票金额小计： ￥{{ amountSum }}</p>
          <div class="f_input_box" v-if="jumpType == 'resubmit'">
            <p class="f_txt">申请备注:</p>
            <div class="f_input_right">
              <el-input v-model="infoForm.StrRemark" type="textarea" rows="4" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="emailBox flex">
          <el-checkbox v-model="appInfo.isInvoiceMail" :true-label="1" :false-label="0" disabled>自动邮件发送电子/数电发票</el-checkbox>
          <div class="emails">接收邮箱：{{ appInfo.emails[0] }}</div>
          <el-checkbox v-model="appInfo.isStatementMail" :true-label="1" :false-label="0" disabled>费用结算单盖章一并电子邮件发送</el-checkbox>
        </div>
        <div class="p_employee_list mt15" v-if="activeName=='4' && isOver">
          <div class="r_edit_title">
            <div class="line_box"></div>
            <span>已开发票</span>
            <div class="down_txt cp" @click="downInvoice()">下载</div>
          </div>
          <div class="p_employee_form">
            <div class="p_employee_item">
              <p class="emp_txt">发票张数:</p>
              <div class="emp_form_txt">{{ alreadyInvoiceView.invoiceCount }}</div>
            </div>
            <!-- <div class="p_employee_item">
              <p class="emp_txt">发票类型:</p>
              <div class="emp_form_txt">{{ alreadyInvoiceView.ticketType }}</div>
            </div> -->
            <div class="p_employee_item">
              <p class="emp_txt">开票方式:</p>
              <div class="emp_form_txt">{{ alreadyInvoiceView.billingMethod.toString() }}</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">票种:</p>
              <div class="emp_form_txt">{{ alreadyInvoiceView.ticketType.toString() }}</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">税额:</p>
              <div class="emp_form_txt">{{ alreadyInvoiceView.amountTax }}</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">发票号码:</p>
              <div class="emp_form_txt">{{ alreadyInvoiceView.invoiceNumber.toString() }}</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">开票备注:</p>
              <div class="emp_form_txt">{{ alreadyInvoiceView.billingNote }}</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">开票时间:</p>
              <div class="emp_form_txt">{{ alreadyInvoiceView.billingTime.toString() }}</div>
            </div>
          </div>
        </div>
        <div class="btn_box">
          <el-button @click="backHandle">返回</el-button>
          <el-button v-if="jumpType == 'resubmit'" type="primary" @click="saveHandle">重新提交申请</el-button>
        </div>
      </div>
      <div class="step_box" v-if="activeName == 'second'">
        <el-steps direction="vertical" :active="1" space="100px">
          <el-step title="提交申请"></el-step>
          <el-step title="发票待办"></el-step>
          <el-step title="审批退回" description=""></el-step>
        </el-steps>
      </div>
      <div class="p_employee_box" v-if="activeName == 'third'">
        <div class="record_list">
          <div class="record_item">
            <p>时间：2020-02-19 12:40:45</p>
            <p>记录：申请人 提交</p>
            <p>处理人: 李四</p>
            <p>备注：XXXXXXX</p>
          </div>
          <div class="record_item">
            <p>时间：2020-02-19 12:40:45</p>
            <p>记录：申请人 提交</p>
            <p>处理人: 李四</p>
            <p>备注：XXXXXXX</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="选择发票格式" :visible.sync="showDown" width="450px">
      <div>
        <el-form>
          <el-form-item label="发票格式:">
            <el-select v-model="wjlx" size="small" placeholder="" style="width: 180px;">
              <el-option value="PDF">
              </el-option>
              <el-option value="OFD">
              </el-option>
              <el-option value="XML">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDown = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmDownInvoice" size="small" :loading="isDowning">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import xz from "@/common"
  import moment from 'moment'
  import * as math from 'mathjs'
  import print from 'print-js'
  export default {
    name: "updatePost",
    data() {
      return {
        active: 'first',
        baseInfo: {},
        infoForm: {
          StrRemark: ''
        },
        loading: false,
        isEdit: 'dtl',
        // 详情参数
        dtlQuery: {
          mainuserid: '',
          useridr: ''
        },
        tableData: [],
        jumpType: 'part',
        type: '',
        id: '',
        isDowning: false,
        appInfo: {}, //f发票信息
        finalStatementViewList: [], //对应结算单
        invoiceFiles: [], //结算单附件
        activeName: '',
        isOver: false,
        amountSum: 0, //合计金额
        invoiceRequisitionDetailsViewList: [],
        alreadyInvoiceView: {},
        isOver: false,
        wjlx: '',
        showDown: false,
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        this.activeName = this.$route.query.activeName
        if (this.activeName == '5' && this.type == 'az') {
          this.GetRedPunchAlreadyInvoiceView()
        } else {
          this.GetInvoiceApplyForView()
        }
        if (this.activeName == '4') {
          this.GetAlreadyInvoiceView(this.id);
        }
      }
    },
    methods: {
      handleClick(tab) {
        this.activeName = tab.name
      },
      GetAlreadyInvoiceView(id) {
        let pagename = this.type == 'bc' ? 'GetAlreadyInvoiceView' : 'GetSingleAlreadyInvoiceView';
        xz.GetAlreadyInvoiceView(id, pagename).then(res => {
          if (res.status == 'ok') {
            this.isOver = true;
            this.alreadyInvoiceView = res.data[0];
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      //打印
      printClick(id, ignoreIds) {
        const style = '.page {margin:0 10mm};' //打印时去掉眉页眉尾
        setTimeout(function () {
          printJS({
            printable: id, // 标签元素id
            type: 'html',
            targetStyles: ['*'],
            style: `.page{margin:10px;height:2000px};table{border-collapse:separate}`,
          });
        }, 500)
        //各个配置项
        //printable:要打印的id。
        //type:可以是 html 、pdf、 json 等。
        //properties:是打印json时所需要的数据属性。
        //gridHeaderStyle和gridStyle都是打印json时可选的样式。
        //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
        //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
        //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
        //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
        //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
      },
      // 提交申请开票
      saveHandle() {

      },
      // 取消
      backHandle() {
        this.$router.push({
          path: "/invoicing",
        });
      },
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
      },
      //获取详情
      GetInvoiceApplyForView() {
        this.loading = true;
        xz.GetInvoiceApplyForView(this.id).then(res => {
          if (res.status == 'ok') {
            if (res.data.length > 0) {
              this.baseInfo = res.data[0];
              this.loading = false;
              this.appInfo = res.data[0];
              this.finalStatementViewList = res.data[0].finalStatementViewList;
              this.invoiceRequisitionDetailsViewList = res.data[0].invoiceRequisitionDetailsViewList;
              this.invoiceFiles = res.data[0].invoiceFiles;
              this.isOver = true;
              this.finalStatementViewList.forEach(element => {
                this.amountSum = math.format(
                  math.add(
                    math.bignumber(Number(this.amountSum)), math.bignumber(Number(element.amountApplied))
                  )
                )
              });
              this.amountSum = parseFloat(this.amountSum)
            } else {
              this.loading = false;
              this.$meseage.error('获取详情出错')
            }
          } else {
            this.loading = false;
            this.$meseage.error(res.msg)
          }
        })
      },
      //红冲详情
      GetRedPunchAlreadyInvoiceView() {
        this.loading = true;
        xz.GetRedPunchAlreadyInvoiceView(this.id).then(res => {
          if (res.status == 'ok') {
            if (res.data.length > 0) {
              this.baseInfo = res.data[0];
              this.loading = false;
              this.appInfo = res.data[0];
              this.finalStatementViewList = res.data[0].finalStatementViewList;
              this.invoiceRequisitionDetailsViewList = res.data[0].invoiceRequisitionDetailsViewList;
              this.invoiceFiles = res.data[0].invoiceFiles;
              this.isOver = true;
              this.finalStatementViewList.forEach(element => {
                this.amountSum = math.format(
                  math.add(
                    math.bignumber(Number(this.amountSum)), math.bignumber(Number(element.amountApplied))
                  )
                )
              });

            } else {
              this.loading = false;
              this.$meseage.error('获取详情出错')
            }
          } else {
            this.loading = false;
            this.$meseage.error(res.msg)
          }
        })
      },
      down(url) {
        var path = this.$store.state.EMP.docPath + url;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
      },
      downInvoice() {
        this.showDown = true;
      },
      //下载发票
      confirmDownInvoice() {
        if (!this.isDowning) {
          this.isDowning = true;
          if (this.type == 'bc') {
            this.alreadyInvoiceView.actualBillingBasicIds.forEach(e => {
              let data = {
                id: e,
                type: 2,
                wjlx: this.wjlx
              }
              this.confirmDownInvoice2(data)
            });
          } else {
            let data = {
              id: this.id,
              type: 1,
              wjlx: this.wjlx
            }
            this.confirmDownInvoice2(data)
          }
        }
      },
      confirmDownInvoice2(data){
        xz.IvoiceFun(data, 'PostThirdParty_downloadFile').then(res => {
            if (res.status == 'ok') {
              this.isDowning = false;
              if (res.data.length > 0) {
                if (res.data[0].data.jgzt == 1) {
                  let url = res.data[0].data.wjdz;
                  const aTag = document.createElement('a')
                  aTag.href = url
                  aTag.click();
                  this.showDown = false;
                } else {
                  this.showDown = false;
                  this.$message.error(res.data[0].data.cwxx)
                }
              }
            } else {
              this.$message.error(res.msg)
              this.isDowning = false;
            }
          })
      },
    }
  }
</script>
<style scoped>
  .down_txt {
    font-size: 14px;
    color: #409EFF;
    margin-left: 20px;
  }

  .record_item {
    padding: 10px;
    color: #555;
    font-size: 14px;
    box-shadow: 0px 4px 6px 0px rgba(104, 11, 255, 0.02);
    background-color: #f2f3f3;
    margin-bottom: 10px;
  }

  .mt15 {
    margin-top: 15px;
  }

  .record_item p {
    margin-top: 5px;
  }

  .s_tabs_box {
    background-color: #fff;
  }

  .step_box {
    background-color: #fff;
    padding: 15px 10px;
    min-height: 300px;
  }

  .f_input_box {
    display: flex;
    margin-top: 20px;
  }

  .f_txt {
    width: 80px;
    font-size: 14px;
    color: #555;
  }

  .f_input_right {
    flex: 1;
  }

  .print_box {
    justify-content: flex-end;
    margin-right: 40px;
  }

  .centerTitle {
    width: 100%;
    /* margin-bottom: 5px; */
    border: 1px solid #000;
    border-bottom: none;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    box-sizing: border-box;
  }

  .com_form_box {
    margin: 15px 0;
    padding: 0 20px;
  }

  .tabtop td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .font-center {
    text-align: center
  }

  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
  }

  .d_txt {
    font-size: 14px;
    color: #555;
    margin-top: 20px;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .dtl_table {
    box-sizing: border-box;
    margin-top: 15px;
  }

  .emp_txt {
    width: 120px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    /* border-bottom: 1px solid #DCDFE6; */
  }

  .emp_form_txt {
    width: 360px;
    font-size: 14px;
    color: #000;
  }

  .txts01 {
    font-size: 14px;
  }

  .p_employee_item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
    line-height: 18px;
  }

  .p_employee_form {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .p_employee_box {
    background-color: #fff;
    padding: 15px 10px;
  }

  .merge {
    padding: 10px 30px;
  }

  .emailBox {
    margin-top: 15px;
  }

  .emails {
    margin: 0 20px;
    font-size: 14px;
  }
</style>
<style>
  .page_pendInvoice .dtl_table .el-table,
  .page_pendInvoice .el-table th.el-table__cell {
    background-color: #E8F7F7;
    /* 你想要的背景色 */
  }

  .form_table td {
    border: #000 1px solid;
  }

  .e_dtl_content .el-table .el-table__cell {
    padding: 4px 0;
  }

  /* .page_pendInvoice .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_pendInvoice .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  } */
</style>